import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { FaBell, FaReply, FaTimes } from "react-icons/fa";

function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [replyLoading, setReplyLoading] = useState(false);
  const [replyMsg, setReplyMsg] = useState("");

  // ✅ جلب الإشعارات الخاصة بالمستخدم
  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await api.get("/notifications/my", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setNotifications(res.data.data || res.data);
    } catch (err) {
      console.error("❌ فشل تحميل الإشعارات", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ تحديد كمقروء
  const markAsRead = async (id) => {
    try {
      await api.put(`/notifications/${id}/read`, null, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
    } catch (err) {
      console.error("❌ فشل تحديد الإشعار كمقروء", err);
    }
  };

  // ✅ إضافة رد
  const addReply = async (id) => {
    if (!replyMsg.trim()) return;
    setReplyLoading(true);
    try {
      await api.post(
        `/notifications/${id}/reply`,
        { message: replyMsg.trim() },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setReplyMsg("");
      fetchNotifications();
    } catch (err) {
      alert("❌ فشل إرسال الرد");
      console.error(err);
    } finally {
      setReplyLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6">
      <h1 className="text-3xl font-bold mb-8 flex items-center gap-2 text-yellow-400">
        <FaBell /> الإشعارات الخاصة بك
      </h1>

      {loading ? (
        <p className="text-center text-gray-400 animate-pulse">⏳ جاري التحميل...</p>
      ) : notifications.length === 0 ? (
        <p className="text-center text-gray-400 text-lg">
          📭 لا توجد إشعارات في الوقت الحالي
        </p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {notifications.map((n) => (
            <div
              key={n._id}
              onClick={() => {
                setSelected(n);
                markAsRead(n._id);
              }}
              className={`relative bg-gray-800 hover:bg-gray-700 border-l-4 cursor-pointer transition-all duration-200 rounded-xl shadow-lg p-5 ${
                n.readBy?.length ? "border-gray-500" : "border-yellow-500"
              }`}
            >
              <h3 className="text-xl font-semibold text-yellow-400 mb-2">
                {n.title}
              </h3>
              <p className="text-gray-300 line-clamp-2">{n.message}</p>
              <small className="text-gray-500 mt-2 block">
                🕒 {new Date(n.createdAt).toLocaleString("ar-EG")}
              </small>
            </div>
          ))}
        </div>
      )}

      {/* ✅ نافذة تفاصيل الإشعار */}
      {selected && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-white text-gray-900 rounded-2xl shadow-2xl w-full max-w-lg relative animate-fadeIn">
            <button
              onClick={() => setSelected(null)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
            >
              <FaTimes size={18} />
            </button>

            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2 text-yellow-600">
                {selected.title}
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                {selected.message}
              </p>
              <small className="text-gray-500 block mb-3">
                🕒 {new Date(selected.createdAt).toLocaleString("ar-EG")}
              </small>

              <hr className="my-4" />

              {/* 💬 الردود */}
              <h4 className="font-semibold text-gray-800 mb-2">💬 الردود:</h4>
              {selected.replies?.length ? (
                <div className="max-h-40 overflow-y-auto space-y-2">
                  {selected.replies.map((r, i) => (
                    <div
                      key={i}
                      className="bg-gray-100 p-2 rounded-md text-sm text-gray-700"
                    >
                      <strong>{r.user?.name || "مستخدم"}:</strong> {r.message}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-400 text-sm">لا توجد ردود بعد</p>
              )}

              {/* ✍️ إدخال الرد */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  addReply(selected._id);
                }}
                className="mt-4 flex gap-2"
              >
                <input
                  type="text"
                  value={replyMsg}
                  onChange={(e) => setReplyMsg(e.target.value)}
                  placeholder="اكتب ردك هنا..."
                  className="flex-1 border border-gray-300 rounded-md p-2 outline-none focus:ring-2 focus:ring-yellow-400"
                />
                <button
                  type="submit"
                  disabled={replyLoading}
                  className={`px-4 py-2 rounded-md text-white flex items-center gap-2 ${
                    replyLoading
                      ? "bg-gray-400"
                      : "bg-yellow-500 hover:bg-yellow-600"
                  }`}
                >
                  <FaReply /> إرسال
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NotificationsPage;
